import * as React from 'react';
import Column from '../Column';
import { styled, CircularProgress } from '@mui/material';
import AnimatedLogo from './AnimatedLogo';

interface Props {
  variant?: 'linear' | 'circle' | 'none';
  logo?: boolean;
  className?: string;
  width?: number | string;
  testId?: string;
  sx?: React.CSSProperties;
}

const Wrapper = styled(Column)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));

const CustomCircularProgress = styled(CircularProgress)(({ theme }) => ({
  '& .MuiLinearProgress-barColorPrimary': {
    backgroundColor: theme.palette.primary.main,
  },
}));

const LoadingScreen: React.FC<Props> = ({ variant = 'linear', logo = false, width, className, testId = 'loading-screen-linear', sx }) => {
  return (
    <Wrapper grow centered className={className} data-testid={testId} style={sx}>
      <>
        {logo && <AnimatedLogo />}
        {variant === 'circle' && (
          <CustomCircularProgress color="primary" data-testid="loading-screen-circle" style={{ width: width ? width : 40, height: width ? width : 40 }} />
        )}
      </>
    </Wrapper>
  );
};

export default LoadingScreen;
